export default {
  actions: {
    user(context, data) {
      return new Promise((resolve, reject) => {
        axios
          .get(data.path + '/user', {
            headers: {
              'Content-Type': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('access_token')
            },
          })
          .then(response => {
            resolve(response)
          }).catch(err => {
          localStorage.removeItem('access_token')
          localStorage.removeItem('user')
          reject(err)
        })
      })
    },
  },
  mutations: {
    toggleHeaderPopup(state, status) {
      state.headerPopupOpen = status
    },
    setErrorText(state, text) {
      state.headerErrorText = text
    },
    changeModalStatus(state, status) {
      state.modalShow = status
    },
    changeModalContent(state, content) {
      state.modalContent = content
    },
    changeModalOKBtnText(state, content){
      state.okBtnText = content
    },
    changeModalTitle(state, title) {
      state.modalTitle = title
    },
    changeModalType(state, type) {
      state.modalType = type
    },
    changeModalCallback(state, callback) {
      state.modalCallback = callback
    }
  },
  state: {
    mainHost: '/',
    storageHost: process.env.MIX_AWS_URL || 'http://localhost/storage/',
    apiHost: '/api/',
    headerPopupOpen: false,
    headerErrorText: null,
    modalShow: false,
    modalType: 'text',
    modalCallback: null,
    modalContent: null,
    okBtnText: null,
    modalTitle: null,
  },
  getters: {
    modalShow(state) {
      return state.modalShow;
    },
    storage(state) {
      return state.storageHost;
    },
    assetHost(state) {
      return state.mainHost;
    },
  }
}
